<template>
  <div class="container mx-auto">
    <!-- Banner -->
    <AppBanner class="mb-5 sm:mb-14" />

    <!-- Projects -->
    <ProjectsGrid />

    <!-- Load more projects button -->
    <div class="flex justify-center">
      <router-link to="/projects"
        class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-cyan-500 hover:bg-cyan-600 focus:ring-1 focus:ring-cyan-900 text-white text-lg sm:text-xl duration-300"
        aria-label="More Projects">
        <Button :title="$t('viewProjects')" />
      </router-link>
    </div>
    <!-- CTA -->
    <div class="mt-16 text-center">
      <h2 class="text-2xl font-semibold text-ternary-dark dark:text-ternary-light mb-4">
        {{ $t('aboutMessage') }}
      </h2>
      <p class="text-lg text-gray-600 dark:text-gray-300 mb-6">
        {{ $t('aboutMessage2') }}
      </p>
      <a href="#contact" class="inline-block px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg transition duration-300">
        {{ $t('aboutContact') }}
      </a>
    </div>
  </div>
</template>

<script>
import AppBanner from '@/components/shared/AppBanner.vue';
import ProjectsGrid from '../components/projects/ProjectsGrid.vue';
import Button from '@/components/reusable/Button.vue';

export default {
  name: 'Home',
  components: {
    AppBanner,
    ProjectsGrid,
    Button,
  },
}
</script>